import { useTranslation } from '@ecomm/i18n'
import { Benefit } from './Benefit'
import { Benefits } from './Benefits'

export function BusinessPlanBenefits({ hideTitle = false }) {
  const { t } = useTranslation('business-monitoring')

  return (
    <div className="text-center">
      {!hideTitle && (
        <h2 className="text-3xl lg:text-5xl mt-1 lg:mt-4 mb-5 font-arizona lg:px-24 not-prose leading-8">
          {t('plan-benefits.monitorings-title')}
        </h2>
      )}
      <div className="bg-neutral-100 rounded-2xl py-3 lg:py-6">
        <h3
          className="text-xl lg:text-3xl tracking-tight font-bold mb-0 lg:mb-3.5"
          id="business-plan-benefits-title"
        >
          {t('plan-benefits.benefits-title')}
        </h3>
        <Benefits>
          <Benefit text={t('plan-benefits.camera-stream')} />
          <Benefit text={t('plan-benefits.pins')} />
          <Benefit text={t('plan-benefits.employee-access')} />
          <Benefit text={t('plan-benefits.customer-support')} />
        </Benefits>
      </div>
    </div>
  )
}
